<ng-container *ngIf="initialized">
<div class="hp-page">
  <div class="hp-outer">

    <!-- Title -->
    <div class="hp-title">
      <h1>Health Picks</h1>
      <p>製品管理画面</p>
    </div>

    <!-- Card -->
    <div class="hp-card">
      <h2>認証メールを確認してください</h2>

      <p class="hp-note">
        登録したメールアドレスに送信した認証メールを確認し、登録を完了してください。
      </p>

      <div class="hp-info-box">
        <p>
          <strong>📧 メールが届かない場合</strong>
        </p>
        <p>
          dx-utility.com のドメインからメールが届きます。届かない場合は、迷惑メールフォルダをご確認ください。
        </p>
        <div class="hp-divider"></div>
        <p>
          認証メールの再送信は
          <button type="button" class="hp-link" (click)="navigateToResend()">
            こちら
          </button>
        </p>
      </div>
    </div>

  </div>
</div>
</ng-container>
